require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-relazioni-e-conferenze-nicola-navone-concrete-in-canton-ticino-an-overview-zurigo-26-gennaio-2019.json") })
        }
      }, "path---en-relazioni-e-conferenze-nicola-navone-concrete-in-canton-ticino-an-overview-zurigo-26-gennaio-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-relazioni-e-conferenze-nicola-navone-concrete-in-canton-ticino-an-overview-zurigo-26-gennaio-2019!./.cache/json/en-relazioni-e-conferenze-nicola-navone-concrete-in-canton-ticino-an-overview-zurigo-26-gennaio-2019.json
// module id = 631
// module chunks = 231608221292675